import { Controller } from "@hotwired/stimulus"
import { startRegistration } from "@simplewebauthn/browser"

export default class extends Controller {
  static targets = ["button"]

  async register(event) {
    event.preventDefault();

    try {
      const options = await this.makeOptionsRegisterRequest();
      const attestationResponse = await startRegistration(options);

      this.makeRegisterRequest(attestationResponse).then((response) => {
        if (response.ok) {
          this.makeRegisterSuccessRequest();
        } else {
          response.json().then(async (data) => {
            await this.makeRegisterFailedRequest(data.error);
          });
        }
      }, error => {
        this.makeRegisterFailedRequest(error.message);
      })
    } catch (error) {
      console.error("Error during registration:", error);
      await this.makeRegisterFailedRequest(error.message);
    }
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]').content;
  }

  reload() {
    window.location = window.location.href;
  }

  async makeOptionsRegisterRequest() {
    const response = await fetch("/passkey/options_register", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.csrfToken,
      },
      credentials: "same-origin"
    });

    return response.json();
  }

  async makeRegisterRequest(attestationResponse) {
    return await fetch("/passkey/register", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.csrfToken,
      },
      credentials: "same-origin",
      body: JSON.stringify({ credential: attestationResponse, nickname: navigator.platform })
    })
  }

  async makeRegisterFailedRequest(error_message) {
    await fetch("/passkey/register_failed", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.csrfToken,
      },
      credentials: "same-origin",
      body: JSON.stringify({ error: error_message })
    })

    this.reload();
  }

  async makeRegisterSuccessRequest() {
    await fetch("/passkey/register_success", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.csrfToken,
      },
      credentials: "same-origin",
    })

    this.reload();
  }
}
